import SimpleSchema from 'simpl-schema'

// WARNING ! We must include uniforms to extend simpl-schema
// eslint-disable-next-line
import uniforms from 'uniforms'
import { Random } from 'meteor/random'
export const INVOICES_STATUS = {
  paid: 'paid',
  unpaid: 'unpaid',
  abandoned: 'abandoned',
}

const schema = {
  _id: {
    type: String,
    uniforms: {
      component: () => null,
    },
    defaultValue: Random.id(),
  },
  status: {
    label: 'Status',
    type: String,
    allowedValues: Object.values(INVOICES_STATUS),
  },
}

export default new SimpleSchema(schema)
